const iconsList = [
    { value: 'kidsPreSchool', iconSet: 'child', label: 'Kids | pre-school', logo: 'mediathekdarkard' },
    { value: 'kidsSchool', iconSet: 'child', label: 'Kids | school', logo: 'mediathekdarkard' },
    { value: 'kidsPreTeens', iconSet: 'child', label: 'Kids | pre-teens', logo: 'mediathekdarkard' },
    { value: 'lightArd', iconSet: 'default', label: 'ARD | light', logo: 'mediatheklightard' },
    { value: 'darkArd', iconSet: 'default', label: 'ARD | dark', logo: 'mediathekdarkard' },
    { value: 'darkAlpha', iconSet: 'default', label: 'alpha | dark', logo: 'alpha' },
    { value: 'darkArte', iconSet: 'default', label: 'arte | dark', logo: 'arte' },
    { value: 'darkBr', iconSet: 'default', label: 'BR | dark', logo: 'br' },
    { value: 'darkDaserste', iconSet: 'default', label: 'Das Erste | dark', logo: 'daserste' },
    { value: 'darkFunk', iconSet: 'default', label: 'funk | dark', logo: 'funk' },
    { value: 'darkHr', iconSet: 'default', label: 'hr | dark', logo: 'hr' },
    { value: 'darkMdr', iconSet: 'default', label: 'mdr | dark', logo: 'mdr' },
    { value: 'darkNdr', iconSet: 'default', label: 'NDR | dark', logo: 'ndr' },
    { value: 'darkOne', iconSet: 'default', label: 'One | dark', logo: 'one' },
    { value: 'darkPhoenix', iconSet: 'default', label: 'phoenix | dark', logo: 'phoenix' },
    { value: 'darkRadiobremen', iconSet: 'default', label: 'Radio Bremen | dark', logo: 'radiobremendark' },
    { value: 'darkRbb', iconSet: 'default', label: 'RBB | dark', logo: 'rbb' },
    { value: 'darkSr', iconSet: 'default', label: 'SR | dark', logo: 'sr' },
    { value: 'darkSwr', iconSet: 'default', label: 'SWR | dark', logo: 'swr' },
    { value: 'darkTagesschau24', iconSet: 'default', label: 'tagesschau24 | dark', logo: 'tagesschau24dark' },
    { value: 'dark3sat', iconSet: 'default', label: '3sat | dark', logo: 'dreisat' },
    { value: 'darkZdf', iconSet: 'default', label: 'ZDF | dark', logo: 'zdf' },
    { value: 'darkWdr', iconSet: 'default', label: 'WDR | dark', logo: 'wdr' },
];
export default iconsList;
